if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    let TitleIntro = document.getElementById('title_intro');
    let TextIntro = document.getElementById('text_intro');

    if(TextIntro && TitleIntro){
        TitleIntro = TitleIntro.innerHTML;
        if(TextIntro.getElementsByTagName('p')[0]){
            TextIntro.getElementsByTagName('p')[0].innerHTML = '<span class="title-copy">'+TitleIntro+'</span>' + TextIntro.getElementsByTagName('p')[0].innerHTML;
        } else {
            TextIntro.innerHTML = '<p><span class="title-copy">'+TitleIntro+'</span>' + TextIntro.innerHTML +'</p>';
        }
    }

    $('.sym-slides').slick({
        accessibility: false
    });

    $('.images-slides').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 500,
        fade: true,
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Back" type="button" style="display: block;">Prev</button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="display: block;">Next</button>',
        accessibility: false
    });

    $('.line-points-slider').slick({
        arrows: true,
        dots: false,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        accessibility: false,
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Back" type="button" style="display: block;">Back</button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="display: block;">Next</button>',
        responsive: [
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });

    $('.reviews-slides').slick({
        arrows: true,
        dots: true,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        accessibility: true,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    dots: false,
                }
            }
        ]
    });

    $('.gallery-slider').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 500,
        fade: true,
        accessibility: true
    });

    $('.slider-slide').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 6000,
        speed: 700,
        fade: true,
        accessibility: true,
        adaptiveHeight: false,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true,
                }
            }
        ]
    });

    $('.slider-bg-content').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 6000,
        speed: 700,
        fade: true,
        accessibility: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true,
                }
            }
        ]
    });

    $('.slider-overlap').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 6000,
        speed: 700,
        fade: true,
        accessibility: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true,
                }
            }
        ]
    });

    $('.slider-featured-slide').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        accessibility: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true,
                }
            }
        ]
    });

    let ScrollDown = document.getElementsByClassName('js-scrolldown');
    if(ScrollDown.length > 0){
        ScrollDown[0].addEventListener('click', function(){
            animateto('intro');
        });
    }

    //FAQ
    setTimeout(function(){
        $('.tab-label').each(function(){
            let thisHeightTap = $(this).height() + 40;
            let thisHeight = $(this).next('.tab-content').height() + thisHeightTap;
            $(this).parent().animate({height: thisHeightTap + 'px'},400);
            if($(this).hasClass('open')){
                $(this).parent().animate({height: thisHeight + 'px'},400);
            }
        });
        $('.learn-more-btn').append('<div class="arrow"></div>');
    }, 400);

    $('.tab-label').click(function(){
        let currentclick = $(this);
        let thisHeightTap = $(this).height() + 40;

        let slideIndex = $(this).data('artwork');
        $(".accordion-slide").slick('slickGoTo', parseInt(slideIndex));

        if(!currentclick.hasClass('open')){
            $('.tab-label').each(function(){
                if($(this) !== currentclick ){
                    if($(this).hasClass('open')){
                        let thisHeight = $(this).height() + 40;
                        $(this).removeClass('open');
                        $(this).parent().animate({height: thisHeight + 'px'},400);
                    }
                }
            });
            currentclick.addClass('open');
            let thisHeight = $(this).next('.tab-content').height() + thisHeightTap;
            $(this).parent().animate({height: thisHeight + 'px'},400);
        } else {
            currentclick.removeClass('open');
            currentclick.parent().animate({height: thisHeightTap + 'px'},400);
        }
    });

    $('[data-fancybox]').fancybox({
        loop : true,
        backFocus: false,
        autoFocus: false,
    });

    $("a[href^='#']:not(:where(a[data-fancybox], a[data-filter], a.accordion-toggle, a#js_btn_book))").click(function(e){
        e.preventDefault();
        let strAncla = $(this).prop('hash').substr(1);
        animateto(strAncla);
    });

    $("input[name*=select_destination]").eq(0).attr("checked", "checked");

    $('.btn, .signup-btn').each(function() {
        let htmlString = $(this).text();
        $(this).html('<span>'+htmlString+'</span>');
    });

    let Body = document.body;
    let BtnBook = document.getElementById('js_btn_book');
    let BookingBox = document.getElementById('js_sub_menu_primary');
    let BookClose = document.getElementById('js_menu_close');

    if(BtnBook){
        BtnBook.addEventListener('click', function(e){
            e.preventDefault();
            BookingBox.classList.add('open');
            Body.classList.add('scroll-no');
        });
    }

    if(BookClose){
        BookClose.addEventListener('click', function(e){
            e.preventDefault();
            BookingBox.classList.remove('open');
            Body.classList.remove('scroll-no');
        });
    }

    const TYPE_EVENTS_SELECT = document.querySelector('select[name="type_of_event"]');
    if(TYPE_EVENTS_SELECT){
        TYPE_EVENTS_SELECT.addEventListener('change', (e) => {

            let valueOfEventSelect = TYPE_EVENTS_SELECT.value;
            let emails = [];

            function change_cc_email(mails){
                let inputCC = document.querySelectorAll("input[name='emailcc[]']");
                if(inputCC){
                    inputCC = [...inputCC];
                    inputCC.forEach(input => {
                        input.remove();
                    });
                }

                mails.forEach(email => {
                    const input = document.createElement('input');
                    input.setAttribute("type", "hidden");
                    input.setAttribute("name", "emailcc[]");
                    input.setAttribute("value", email);
                    document.querySelector('form.form-module').appendChild(input);
                });
            }

            switch (valueOfEventSelect) {
                case 'restaurant_holiday_parties':
                    emails = ['Rob.anderson@fairmont.com', 'Calli.Wecker@Fairmont.com']
                    change_cc_email(emails);
                    break;
                case 'catering':
                    emails = ['Calli.Wecker@Fairmont.com', 'Sally.Kukla@Fairmont.com']
                    change_cc_email(emails);
                    break;
                case 'attraction_buyouts':
                    emails = ['Anthony.Dennis@Fairmont.com', 'Teresa.Thompson2@Fairmont.com']
                    change_cc_email(emails);
                    break;
            }

        });
    }

})();

function animateto(target){
    var gotoTarget = offset(document.getElementById(target)).top - 130;
    var from     = window.pageYOffset
    var to       = gotoTarget
    var duration = 1300;
    var start = new Date().getTime()

    //time interval
    var timer = setInterval(function() {
        var time = new Date().getTime() - start

        if(from <= to ){
            var y = easeInOutQuart(time, from, to - from, duration)
        } else {

            var y = easeInOutQuart(time, from, -(from - to), duration)
        }
        window.scrollTo(0, y)
        if (time >= duration) clearInterval(timer)

    }, 1000 / 60);

    window.scrollTo(0, from)

}
//ease movement
function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}